<ui-radio-group
	ngDefaultControl
	[formControl]="formControl"
	[formlyAttributes]="field"
	[options]="props['entries']"
></ui-radio-group>
